import NavigationCard from './navigation-card';
export default NavigationCard;
